import { createContext } from 'react';

export type MenuContextValue = {
  isCollapsed: boolean;
};

export const MenuContext = createContext<MenuContextValue>({
  isCollapsed: false,
});
